import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-blue",
  "use": "icon-check-blue-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check-blue\">\n<path d=\"M10.211 0.345323L11.3051 1.43942L4.94118 7.80338L0.698539 3.56074L1.7592 2.50008L4.90775 5.64862L10.211 0.345323Z\" fill=\"#13B3E3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol